import { createSlice } from '@reduxjs/toolkit';
import { API } from 'store/middleware/api';

export const initialState = {
	siteId: null,
	visitId: null,
	traffic_source_id: null,
	cid: null,
	ctid: null,
	user_ip: null,
	gaClientId: null,
	gclid: null
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase('SFDC/USER/SAVE_BATCH_META_SUCCESS', (state, action) => ({
				...state,
				...(action.meta?.gcid && { gaClientId: action.meta.gcid }),
				...(action.meta?.gclid && { gclid: action.meta.gclid })
			}));
	},
});

export const USER = {
	UNSUBSCRIBE_REQUEST: 'SFDC/USER/UNSUBSCRIBE_REQUEST',
	UNSUBSCRIBE_SUCCESS: 'SFDC/USER/UNSUBSCRIBE_SUCCESS',
	UNSUBSCRIBE_FAILURE: 'SFDC/USER/UNSUBSCRIBE_FAILURE'
};

export function unsubscribe(data) {
	return {
		[API]: {
			method: 'POST',
			types: [USER.UNSUBSCRIBE_REQUEST, USER.UNSUBSCRIBE_SUCCESS, USER.UNSUBSCRIBE_FAILURE],
			endpoint: '/unsubscribe',
			data
		}
	};
}

export default userSlice.reducer;
